import { FieldType, FilterOperatorType } from '@crm/types'
import { Form, Select } from 'antd'

import { TaskFormElement } from './types'

type Props = {
  key: number
  element: TaskFormElement
  values?: Record<string, string>
  required?: boolean
}

export const OperatorElement = ({ key, element, values, required }: Props) => {
  return (
    <Form.Item
      name={element.name}
      key={key}
      label={element.label}
      rules={[{ required }]}
    >
      <Select
        options={
          values?.type?.includes(FieldType.LINK)
            ? Object.values(FilterOperatorType)
                ?.filter(
                  (item) =>
                    ![
                      FilterOperatorType.GT,
                      FilterOperatorType.GTE,
                      FilterOperatorType.LT,
                      FilterOperatorType.LTE,
                      FilterOperatorType.IS_NULL
                    ].includes(item)
                )
                ?.map((item) => ({
                  value: item,
                  label: item
                }))
            : Object.values(FilterOperatorType)?.map((item) => ({
                value: item,
                label: item
              }))
        }
      />
    </Form.Item>
  )
}
